import React from 'react'
import { Loading } from '../../shared/Loading'

const ModalSpinnerComponent = () => {
  return (
   <Loading centered={true}/>
  )
}
export const ModalSpinner = ModalSpinnerComponent
